/** Max scale of the floor plan image inside gray preview tiles (dashboard + analytics). */
export const FLOOR_PLAN_PREVIEW_MAX_SCALE = '80%';
